<template>
  <v-my-layout>
    <v-my-card slot="body">
      <v-card-title>
        <h1 class="text-xs-center">
          Admin
        </h1>
      </v-card-title>

      <v-tabs
        centered
        class="admin-tabs"
      >
        <v-tabs-slider color="#193b95" />
        <v-tab
          v-if="this.$store.state.auth.user.admin"
          to="#companies"
        >
          {{
            $t("general.admin.tabs.companies.title")
          }}
        </v-tab>
        <v-tab
          v-if="this.$store.state.auth.user.admin"
          to="#devices"
        >
          {{
            $t("general.admin.tabs.devices.title")
          }}
        </v-tab>
        <v-tab
          v-if="this.$store.state.auth.user.admin || this.$store.state.auth.user.isCompanyOwner"
          to="#users"
        >
          {{ $t("general.admin.tabs.users.title") }}
        </v-tab>
        <v-tabs-items class="tabs-container">
          <v-tab-item
            v-if="this.$store.state.auth.user.admin"
            value="companies"
          >
            <v-companies-table
              class="custom-table"
            />
          </v-tab-item>

          <v-tab-item
            v-if="this.$store.state.auth.user.admin"
            value="devices"
          >
            <div class="tab-item-wrapper">
              <v-devices-table
                class="custom-table"
              />
            </div>
          </v-tab-item>

          <v-tab-item
            v-if="this.$store.state.auth.user.admin || this.$store.state.auth.user.isCompanyOwner"
            value="users"
          >
            <div class="tab-item-wrapper">
              <v-users-table
                class="custom-table"
              />
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-my-card>
  </v-my-layout>
</template>

<script>
/* ============
 * Admin Index Page
 * ============
 *
 * The admin index page.
 */

import VMyLayout from '@/layouts/Default.vue';
import VCompaniesTable from '@/components/CompaniesTable.vue';
import VDevicesTable from '@/components/DevicesTable.vue';
import VUsersTable from '@/components/UsersTable.vue';
import VMyCard from '@/components/Card.vue';

export default {
  name: 'AdminIndex',

  components: {
    VMyLayout,
    VCompaniesTable,
    VDevicesTable,
    VUsersTable,
    VMyCard,
  },

  data() {
    return {
      editedIndex: -1,
      editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
    };
  },
};
</script>

<style lang="scss">
</style>
